export default 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M4.24 7.74a.83.83 0 0 1 1.18 0L7 9.31l3.58-3.57a.83.83 0 0 1 1.18 1.18L7 11.67 4.24 8.92a.83.83 0 0 1 0-1.18';